import React from "react"
import * as wjcGrid from "@grapecity/wijmo.grid"

export type ReactUseState<T> = {
  state: T
  setState: React.Dispatch<React.SetStateAction<T>>
}

export const IsSearchingContext = React.createContext<ReactUseState<boolean>>(
  {} as ReactUseState<boolean>
)

export const IsRestoreSearchingContext = React.createContext<
  ReactUseState<boolean>
>({} as ReactUseState<boolean>)

export const GridInitializedContext = React.createContext<
  ReactUseState<boolean>
>({} as ReactUseState<boolean>)

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<any[] | undefined>([])

export const FlexGridContext = React.createContext<
  ReactUseState<wjcGrid.FlexGrid | undefined>
>({} as ReactUseState<wjcGrid.FlexGrid | undefined>)

export const seikyuGoukeiUpdateDyContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const seikyuSyoriStatKbnContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const seikyuDyContext = React.createContext<ReactUseState<string>>(
  {} as ReactUseState<string>
)

/**
 * 請求明細入力のProvider
 */
export const InvoiceListProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<Object> | undefined
  FlexGrid: ReactUseState<wjcGrid.FlexGrid | undefined>
  seikyuGoukeiUpdateDy: ReactUseState<string | null | undefined>
  seikyuSyoriStatKbn: ReactUseState<string | null | undefined>
  seikyuDy: ReactUseState<string>
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            <FlexGridContext.Provider value={props.FlexGrid}>
              <seikyuGoukeiUpdateDyContext.Provider
                value={props.seikyuGoukeiUpdateDy}>
                <seikyuSyoriStatKbnContext.Provider
                  value={props.seikyuSyoriStatKbn}>
                  <seikyuDyContext.Provider value={props.seikyuDy}>
                    {props.children}
                  </seikyuDyContext.Provider>
                </seikyuSyoriStatKbnContext.Provider>
              </seikyuGoukeiUpdateDyContext.Provider>
            </FlexGridContext.Provider>
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
